'use strict';
const _ = require('lodash');
const $ = require('jquery');
const Backbone = require('backbone');
const PubSub = require('../PubSub');
const ViewTimer = require('./timer');
const template = require('../templates/footer.ejs');
const templateCSS = require('../templates/footer.css.ejs');
const CSSView = require('./css');

module.exports = Backbone.View.extend({
    className: 'view-footer',
    events: {
        'click .sign-out': 'signout',
        'click .login': 'login'
    },
    /**
     *
     */
    initialize: function (options) {
        _.bindAll(this, 'render');

        options = options || {};

        this.uid = options.uid;
        this.style_id = this.className + "_" + Math.round(Math.random() * 1000000);
        this.css = this.model.get('copy')['customization'];
        this.$el.addClass(this.style_id);
        this.auth = this.model.get('auth');
        this.window = this.model.get('window');
        this.modelTimer = options.modelTimer;

        this.initCountdown();

        this.listenTo(this.auth, 'change:isAuthorized', this.updateLogoutButton.bind(this));
        this.listenTo(this.model, 'change:copy', this.renderAll.bind(this));
        this.listenTo(this.window, 'change:appState', this.updateCountdown.bind(this));
    },
    /**
     *
     */
    render: function () {
        if(this.CSSView) this.CSSView.remove();

        this.CSSView = new CSSView({
            model: this.css,
            namespace: '#' + this.uid + ' .' + this.style_id + '.' + this.className,
            template: templateCSS
        });

        Backbone.$('head').append(this.CSSView.render().$el);
        this.$el.html(template(this.model.get('copy')));
        return this;
    },
    /**
     *
     */
    renderedToDom: function() {
        if(this.window.get('appState') === 'open' && this.model.get('copy').display_countdown === '1' && this.modelTimer.attributes.isResetting) {
            this.$('.tswdg-countdown').append(this.countdownView.render().$el);
            this.countdownView.renderedToDom();
        }
        this.updateLogoutButton();
    },
    /**
     * Call the render and renderedToDom functions
     */
    renderAll: function() {
        this.render();
        this.renderedToDom();
    },
    /**
     * Initialize the countdown timer
     */
    initCountdown: function() {
        this.countdownView = new ViewTimer({
            model: this.modelTimer,
            allowReset: true,
            countdownCopy: this.model.get('countdownCopy')
        });
    },
    /**
     * Updates the countdown timer
     */
    updateCountdown: function() {
        if(this.window.get('appState') !== 'open') {
            this.countdownView.remove();
        } else {
            this.initCountdown();
        }
        this.renderAll();
    },
    /**
     * Updates the log out button
     */
    updateLogoutButton: function() {
        if(this.auth.get('isAuthorized')) {
            this.$('.auth').show();
        } else {
            this.$('.auth').hide();
        }
    },
    /**
     * [signout description]
     * @return {[type]} [description]
     */
    signout: function() {
        var omParams = { name: 'logout button', url: window.location.href };
        var gaParams = { eventCategory: 'Button Click', eventAction: 'Logout' };

        PubSub.trigger('linkClick', omParams, gaParams);
        PubSub.trigger('logout');
    },
    /**
     * [login description]
     * @return {[type]} [description]
     */
    login: function() {
        var omParams = { name: 'login button', url: window.location.href };
        var gaParams = { eventCategory: 'Button Click', eventAction: 'Login' };

        PubSub.trigger('linkClick', omParams, gaParams);
        PubSub.trigger('directRoute', 'auth');

        $('.navbar').removeClass('open');
    },
    /**
     * Remove the footer view
     */
    remove: function() {
        this.countdownView.remove();
        this.stopListening();
        return Backbone.View.prototype.remove.call(this);
    }
});



// WEBPACK FOOTER //
// ./app/scripts/views/footer.js